import { render, staticRenderFns } from "./AddEditCommonFile.vue?vue&type=template&id=8a52f3cc"
import script from "./AddEditCommonFile.vue?vue&type=script&lang=js"
export * from "./AddEditCommonFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports